import { SonarRecord } from '@ui/records';
import { SonarObjectType } from '@sonar-software/sonar-ts-types';
import React, { useCallback } from 'react';
export const PeriscopeProcessBuilder = ({ onBuilderClick, builder, showType }) => {
    const handleClick = useCallback(() => {
        if (onBuilderClick) {
            onBuilderClick(builder);
        }
    }, [builder, onBuilderClick]);
    return (React.createElement(SonarRecord, { isActive: builder.isActive, name: builder.displayName, onClick: handleClick, showType: showType, sonarObjectId: builder.sonarObjectId, sonarObjectType: SonarObjectType.SalesforceProcessBuilder, versionNumber: builder.versionNumber }));
};
